import {Card} from 'shells/card/card';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

interface Props {
    label: string;
    children: React.ReactNode;
}

export function StatCard(props: Props) {
    return (
        <Card hasBorder={true}>
            <div className='pad-16'>
                <Stack spacing={4}>
                    <Body color='light' size='small'>
                        {props.label}
                    </Body>
                    {props.children}
                </Stack>
            </div>
        </Card>
    );
}
